export function OverrideMapObject(options?: {}) {
    return function (target: any, key: string) {
        Object.defineProperty(target, key, {
            get: () => {
                return { mapType: 'array', options: options };
            },
            enumerable: true
        });
    };
}
